import React from "react";
import IconButton from "@mui/material/IconButton";
import {
    Alert,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import {useState, useEffect} from "react";
import { useDispatch, useSelector} from "react-redux";
import { addUserToDepartment } from "../../index";
import {Loader} from "../../../../../Components";
import {setModal} from "../../../../Common/App";
import {AutoCompleteUsers} from "../Forms/AutoCompleteUsers";

export const AssignUserToDepartment = () => {

    const dispatch = useDispatch();
    const item = useSelector((store) => store.departments.selected);
    const [isLoading, setIsLoading] = useState(false);
    const [, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("info");

    const [data, setData] = useState({
        id: "",
        department_id: "",
    });

    useEffect(() => {
        setData({
            department_id: item.id,
        });
    },[item])

    const handleSubmit = async () => {
        setIsLoading(true);
        await addUserToDepartment({dispatch, data}).then((res) => {
            setIsLoading(false);
            if(res.success){
                dispatch(setModal({component:null, open:false}));
            }
            setMessage(res.message);
            setErrors(res.errors);
            setStatus(res.status)
        });
    };

    return(
        <Card sx={{ height: '100%', position:'relative', display: 'flex', flexDirection:'column', alignItems:'stretch', justifyContent:'flex-start', alignContent:'stretch' }}>
            <CardHeader
                action={
                    <IconButton aria-label="share" onClick={()=> dispatch(setModal({component:null, open:false}))}>
                        <CloseIcon />
                    </IconButton>
                }
                title={"Assign Employee to Department"}
                avatar={
                    <Loader isLoading={isLoading} type="linear" />
                }
            />
            <CardContent sx={{ flex:1 }}>
                <Grid container spacing={3}>
                    {message && (
                        <Grid item xs={12}>
                            <Alert severity={status}>{message}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <AutoCompleteUsers field="id" data={data} setData={setData} selectedUser={data['id']} filters={{ department_id: "" }} />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions className={'card-footer'} sx={{ p:2, display:'flex', justifyContent:'space-between'}}>
                <Button variant={'contained'} color={'inherit'} onClick={()=> dispatch(setModal({component:null, open:false}))}>Close</Button>
                <Button color="primary" variant="contained" onClick={ handleSubmit }>Assign</Button>
            </CardActions>
        </Card>
    )
}
